import React, { useEffect, useState } from 'react';
import { GetAlllogsApi } from "../../../api/request/logs";
import moment from "moment";
import { useSelector } from "react-redux";
import TableWithSkeleton from '../../../components/table/TableWithSkeleton.jsx';
import Pagination from '../../../components/pagination/Pagination.jsx';
import columns from '../../../columns/UserLogs.js';

export default function Logs() {
    const [isLoading, setIsLoading] = useState(false);
    const [totalRecord, setTotalRecord] = useState(0);
    const [data, setData] = useState([]);
    const { userDetails } = useSelector(state => state.user);
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);

    const getAllIB = async () => {
        try {

            let params = {
                PageNumber: page,
                PageSize: pageSize,
            }
            setIsLoading(true);
            const { data: response } = await GetAlllogsApi(userDetails._id, new URLSearchParams(params).toString());
            if (response?.success) {
                setData(
                    response?.data?.map((item) => ({
                        ...item,
                        createdDate: moment(item?.createdDate).format('DD-MM-YYYY, hh:mm A'),
                    }))
                );
                setTotalRecord(response?.totalItems);
            }
        } catch (error) {
            console.error('Failed to fetch logs:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getAllIB();
    }, [page, pageSize,]);

    return (
        <div>
            {/* <div className='border-[2px] border-light rounded-xl pt-4 w-full'>
                <div className='px-4 lg:px-6 pb-4 border-b border-light flex flex-wrap justify-between items-center'>
                    <p className='text-[#2F2B3D] text-xl font-semibold'>User Logs</p>
                </div>
                <div className="lg:p-6 p-4">
                    <div className='flex flex-wrap'>
                        <p className="primary text-xl font-semibold">Message :- </p>
                        <p className="text-[#2F2B3D] text-base mt-1 ml-3">Hello admin</p>
                    </div>
                    <div className='flex flex-wrap'>
                        <p className="primary text-base mt-2">Update Date :- </p>
                        <p className="text-[#2F2B3D] text-base mt-2 ml-3">25-07-2024 11:23 AM</p>
                    </div>
                </div>
            </div> */}

            <div>
                <div className="border border-gray-200 rounded-xl">
                    <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
                </div>
                <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
            </div>
        </div>
    );
}
